module.exports = __webpack_public_path__ + "static/media/note-2-color.9a6b2381.svg";